import { ApplicationState } from "#store/types";
import {
    ConfigurationParameters,
    FetchParams,
} from "@inode/pilot-client-typescript-fetch";

export const baseCfg = (
    basePath: string,
    userId: string
): ConfigurationParameters => {
    return {
        basePath: basePath,
        middleware: [
            {
                pre: ({ init, ...rest }): Promise<FetchParams> => {
                    return Promise.resolve({
                        init: {
                            mode: "cors",
                            ...init,
                        },
                        ...rest,
                    });
                },
            },
        ],
        headers: {
            "X-Reference-Id": userId,
        },
    };
};
